import { Box, Typography } from "@mui/material";

export function initiativeDescriptionSections(description: string) {
  return description
    .replace(/\r\n/g, "\n")
    .split(/\n{2,}/)
    .map((section) => section.trim())
    .filter((section) => section.length > 0);
}

export default function InitiativeDescription({
  description,
  websiteUrl,
}: {
  description: string;
  websiteUrl: string;
}) {
  return (
    <Box mb={6}>
      {initiativeDescriptionSections(description).map((section) => (
        <Typography key={section} sx={{ whiteSpace: "pre-line", mb: 2 }}>
          {section}
        </Typography>
      ))}
      <Typography>Learn more at {websiteUrl}.</Typography>
    </Box>
  );
}
